import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Tabs from './tabs';
import Tab from './tab';

class JingPin extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        current: PropTypes.number,
        handleChangeTab: PropTypes.func,
    };

    render() {
        const { content, current, handleChangeTab } = this.props;

        return (
            <div className={styles.tab_all}>
                <div className={styles.tabs_box}>
                    <Tabs content={content} current={current} handleChangeTab={handleChangeTab} />
                </div>
                <div className={styles.tab_box}>
                    <Tab content={content[current].data} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(JingPin);
